import Utility from "../../Utility/Utility";
import { Card } from "../Card/Card";
import { Text } from "../../Text/Text/Text";
import { Theme } from "../../Background/Theme/Theme";
import { Breakpoint } from "../../Responsive/Breakpoint/Breakpoint";
import styles from "./MastheadSmallCard.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MastheadSmallCard = function MastheadSmallCard(_ref) {
  var onClick = _ref.onClick,
    _ref$link = _ref.link,
    link = _ref$link === void 0 ? '' : _ref$link,
    _ref$newWindow = _ref.newWindow,
    newWindow = _ref$newWindow === void 0 ? false : _ref$newWindow,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? {
      text: '',
      alignment: 'left',
      typography: 'headline3',
      ariaLevel: 3,
      variant: 'default'
    } : _ref$heading,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? {
      mobile: {
        url: ''
      },
      desktop: {
        url: ''
      },
      alt: ''
    } : _ref$image,
    _ref$imageOnTop = _ref.imageOnTop,
    imageOnTop = _ref$imageOnTop === void 0 ? false : _ref$imageOnTop,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? '#00058F' : _ref$backgroundColor,
    _ref$dropShadow = _ref.dropShadow,
    dropShadow = _ref$dropShadow === void 0 ? false : _ref$dropShadow,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'darkBackground' : _ref$theme,
    _ref$cardActionAttrib = _ref.cardActionAttributes,
    cardActionAttributes = _ref$cardActionAttrib === void 0 ? {} : _ref$cardActionAttrib,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var renderCardImg = function renderCardImg() {
    var _image$mobile, _image$desktop, _image$desktop2;
    var oneX = function oneX(imageLink) {
      return imageLink ? Utility.getOptimizedCloudinaryUrl(imageLink, {
        width: 380
      }) : '';
    };
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(Breakpoint, {
        breakpoint: "small",
        children: [(image === null || image === void 0 ? void 0 : (_image$mobile = image.mobile) === null || _image$mobile === void 0 ? void 0 : _image$mobile.url) && /*#__PURE__*/_jsx("img", {
          className: styles.smallCardImage,
          src: oneX(image.mobile.url),
          alt: image === null || image === void 0 ? void 0 : image.alt,
          loading: "lazy"
        }), (image === null || image === void 0 ? void 0 : (_image$desktop = image.desktop) === null || _image$desktop === void 0 ? void 0 : _image$desktop.url) && /*#__PURE__*/_jsx("img", {
          className: styles.smallCardImage,
          src: oneX((_image$desktop2 = image.desktop) === null || _image$desktop2 === void 0 ? void 0 : _image$desktop2.url),
          alt: image === null || image === void 0 ? void 0 : image.alt,
          loading: "lazy"
        })]
      })
    });
  };
  var renderCardHeading = function renderCardHeading() {
    return /*#__PURE__*/_jsx("div", {
      className: styles.smallCard,
      style: {
        backgroundColor: backgroundColor
      },
      children: /*#__PURE__*/_jsx("div", {
        className: styles.smallCardText,
        children: /*#__PURE__*/_jsx(Theme, {
          theme: theme,
          children: heading && /*#__PURE__*/_jsx(Text, {
            align: heading.alignment,
            ariaLevel: heading.ariaLevel,
            typog: heading.typography,
            className: styles.smallCardTitle,
            richText: true,
            variant: heading.variant,
            children: heading.text
          })
        })
      })
    });
  };
  var renderTop = function renderTop() {
    return imageOnTop ? renderCardImg() : renderCardHeading();
  };
  var renderBottom = function renderBottom() {
    return imageOnTop ? renderCardHeading() : renderCardImg();
  };
  return /*#__PURE__*/_jsx(Card, {
    bottom: renderBottom(),
    link: link,
    top: renderTop(),
    dropShadow: dropShadow,
    onClick: onClick,
    newWindow: newWindow,
    styleVersion: "v1",
    cardActionAttributes: cardActionAttributes,
    className: className
  });
};